import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import type { StudyView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function StudyRecord() {
  const { slug } = useParams();
  const [study, setStudy] = useState<StudyView | null>(null);
  useEffect(() => {
    if (!slug) return;
    api<StudyView>(`/api/studies/${slug}`).then(setStudy).catch(() => setStudy(null));
  }, [slug]);
  if (!study) return <section className="page-hero"><div className="wrap"><p className="muted">Loading study…</p></div></section>;
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Study · {study.systemName}</p>
        <h1>{study.title}</h1>
        <div className="record-meta">
          <span>{study.publishedAt}</span>
          <span>{study.commissioning}</span>
          <span>{study.consultancy}</span>
          <StatusPill status={study.epistemic} />
          <StatusPill status={study.status} />
        </div>
        <p className="summary">{study.summary}</p>
        <p>{study.purpose}</p>
        <p className="muted">Software: {study.software ?? "Not documented"} · {study.dimensionality}</p>
        {study.sourceUrl && (
          <p>
            <a href={study.sourceUrl} rel="noreferrer">
              Canonical source (not republished)
            </a>
          </p>
        )}
        <p>
          <Link to={`/system/${study.systemSlug}`}>Open Flood System Record</Link>
        </p>
      </div>
    </section>
  );
}
